import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@mui/material";
import {Form, Formik} from "formik"
// import axios from "axios";
import React, { useEffect, useState } from "react";
// import { rowDetailType } from "./MemberTable";
//import Waveform from "../../component/common/waveSurfer/WaveForm.js";
import api from "../../../../../API";
import { StringDecoder } from "string_decoder";
import { useSelector } from "react-redux";
import { getConTypeText } from "./MemberAssignmentTable";

// interface userDetailProps {
  
// }
interface AssignMentProps {
  con_type: string;
  setListDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}


const AssignMentListDialog = (props: AssignMentProps) => {
  console.log("props", props);
  const [con_type, setCon_type] = useState(props.con_type);
  const [script, setScript] = useState([]);
  const [member, setMember] = useState([]);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const scriptList = async () => {
    api.get('/scriptList', {params:{email:email,con_type:con_type}})
    .then((res:any) => {console.log("할당 현황 스크립트 리스트 ", res.data.datas); setScript(res.data.datas); })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const getAssignMentMember = async () => {
    var result = await api.get("/scriptWorkerList",{params:{email:email,con_type:con_type}});
    console.log("result.data", result.data);
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        id: idx + 1,
        email: data.email,
        name: data.name,
        birth: data.birth,
        gender: data.gender,
        phone: data.phone,
        manager_email: data.manager_email,
        manager_name: data.manager_name,
        count: data.count,
      };
    });
    // table에 넣을 rows 데이터 state에 저장
    setMember(datas);
  };

  useEffect(() => {
    scriptList()
    getAssignMentMember()
  }, []);

  return (
    <Box >
    <Dialog maxWidth="xl" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>{getConTypeText(con_type)} - 작업할당</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{display:"flex"}}>
          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>할당 스크립트 목록(<b style={{color:"#03cf5d"}}>{script.length}</b> 건)</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"440px",fontSize:"12px"}}>
              <Table sx={{ minWidth: 500 }} size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",width:"30px", color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>관리 PK</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",width:"55px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>주제</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",width:"50px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>주제세부</Box></TableCell> */}
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당정보</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당일자</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>요약</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>키워드</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당워커ID</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>녹음파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>자막파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>사진파일</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {script.length > 0 ? script.map((row:any, idx:number) => (
                    <React.Fragment key={idx+1}>
                      <TableRow
                        key={idx+1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.mgm_con_pk}</Box></TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{getConTypeText(row.con_type)}</Box></TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.worker_name}</Box><Box sx={{fontSize:"10px"}}>({row.worker_id})</Box></TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.ins_date}</Box></TableCell>
                        {/* <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.summary}</Box></TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.knowledge}</Box></TableCell> */}
                        {/* <TableCell align="left">{row.worker_id}</TableCell> */}
                        {/* <TableCell align="left">{sample.file_srt}</TableCell>
                        <TableCell align="left">{sample.file_photo}</TableCell> */}
                      </TableRow>
                    </React.Fragment>
                  )):""}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>할당 목록</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"440px",fontSize:"12px"}}>
              <Table sx={{ minWidth: 400 }} size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>워커 정보</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>중간관리자</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",width:"50px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당 건수</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",width:"50px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>생년월일</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>성별</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>연락처</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당워커ID</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>녹음파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>자막파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>사진파일</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {member.length > 0 ? member.map((row:any, idx:number) => (
                    <React.Fragment key={idx+1}>
                      <TableRow
                        key={idx+1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                            <TableCell component="th" scope="row" align="center">
                              <Box>{row.name}({row.email})</Box>
                              <Box>{row.gender}({row.phone})</Box>
                            </TableCell>
                            <TableCell component="th" scope="row" align="center">
                              <Box>{row.manager_name}({row.manager_email})</Box>
                            </TableCell>
                            <TableCell align="left">

                            <Formik
                              initialValues={{con_type:con_type,email:row.email, work_cnt:row.count}}
                              onSubmit={(values) => {
                                console.log(values);
                              }}
                            >
                              {({ values, handleChange, setFieldValue, submitCount }) => (
                                <Form>
                                
                                <Box sx={{fontSize:"10px", display:"flex", justifyContent:"center"}}>
                                  <TextField sx={{width:"80px"}} id="work_cnt" name="work_cnt" size="small" type="number"
                                    value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                                    onChange={(e) => {
                                      const newValue = parseInt(e.target.value, 10);
                                      if (newValue > script.length) {
                                        setFieldValue("work_cnt", script.length);
                                      }else{handleChange(e);}
                                    }}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                  {/* <Box>건</Box> */}
                                  {/* {submitCount ? <Button variant="contained" sx={{backgroundColor:"#03cf5d"}}>완료</Button>: <Button variant="contained" type="submit">할당</Button>} */}
                                  
                                </Box>
                                
                                </Form>
                              )}
                            </Formik>

                            </TableCell>
                        {/* <TableCell align="left">{row.worker_id}</TableCell> */}
                        {/* <TableCell align="left">{sample.file_srt}</TableCell>
                        <TableCell align="left">{sample.file_photo}</TableCell> */}
                      </TableRow>
                    </React.Fragment>
                  )):""}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" sx={{fontWeight:800, margin:"8px 16px"}}
          onClick={() => {
            props.setListDialogOpen(false)
          }}
        >
          취소
        </Button>
        <Button variant="contained" color="primary" sx={{fontWeight:800, margin:"8px 16px"}}
          onClick={() => {
            // props.setDialogOpen(false);
            console.log('member ' , member)
          }}
        >
          확인
          {/* 취소
        </Button>
        <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          // onClick={() => { */}
          {/* //   // sampleReject();
          //   setRejectPageOpen(true);
          // 
        > */}
          {/* 샘플 검수반려 */}
        {/* </Button>
        <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}} */}
          {/* // onClick={() => { */}
          {/* //   sampleConfirm();
          // 
        > */}
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default AssignMentListDialog;
